import styled, { css } from 'styled-components';

import { Box } from '@/components/Box';

export const OrSeparatorContainer = styled(Box)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  ${({ theme }) => css`
    color: ${theme.colors.secondaryGrey}
    transition: ${theme.transitions.create('color')};
    font-weight: ${theme.fontWeights.regular};
    font-size: ${theme.fontSizes.p2};
    margin: ${theme.spacing(1.5, 0)};
  `}

  span {
    white-space: nowrap;
  }
`;

export const Line = styled.div`
  width: 48px;
  height: 1px;
  background: #dbdbdb;
`;

export const TextWrapper = styled.span`
  ${({ theme }) => css`
    margin: ${theme.spacing(0, 1)};
    text-transform: uppercase;
  `}
`;
